var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_1207)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 100,
    height: 100,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_1207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4102 68.1789L47.8171 70.619C48.1094 71.1327 48.5302 71.5367 49.0245 71.8308L54.071 68.2528L54.0802 63.1159L49.0441 60.847L44 63.0979C43.999 63.666 44.1446 64.2344 44.4369 64.7481L46.4102 68.1789Z",
    fill: "#0066DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0183 52.863L60.2816 46.1715L54.9938 44.1301C54.4984 44.4224 54.0762 44.8249 53.782 45.3375L44.4428 61.4491C44.1487 61.9618 44.001 62.5297 44 63.0978L54.0802 63.1158L60.0183 52.863Z",
    fill: "#00AD3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0183 52.863L64.8623 50.2571L65.074 44.1481C64.5797 43.8539 64.0117 43.7063 63.4253 43.7052L56.6441 43.6931C56.0576 43.6921 55.4891 43.856 54.9938 44.1301L60.0183 52.863Z",
    fill: "#00831E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9198 63.137L54.0802 63.1159L49.0245 71.8308C49.5188 72.1249 50.0868 72.2725 50.6732 72.2736L69.294 72.3068C69.8805 72.3079 70.449 72.144 70.9443 71.8699L70.964 66.0162L65.9198 63.137Z",
    fill: "#0084FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9444 71.87C71.4397 71.5776 71.862 71.1752 72.1561 70.6625L72.7444 69.6556L75.5572 64.8038C75.8514 64.2912 75.999 63.7233 76 63.1551L70.1737 60.0894L65.9382 63.1372L70.9444 71.87Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9223 53.4323L66.2815 45.3598C65.9892 44.8461 65.5684 44.4421 65.074 44.148L60.0183 52.8629L65.9197 63.137L75.9816 63.155C75.9826 62.5869 75.837 62.0184 75.5447 61.5047L70.9223 53.4323Z",
    fill: "#FFBA00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_1207",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_1207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_1207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_1207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(44 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google_drive.517d62cddebbd2bdd3d0864e29d4225b.svg";
export { ForwardRef as ReactComponent };